export enum UInspectEventTypeEnum {
  ShowEditFormatModal,
  FormatUpdated
}
